import React, { FC, LabelHTMLAttributes, ReactElement } from "react";
import cn from "classnames";
import Styles from "./forms.module.scss";

interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  name?: string;
  klass?: string;
  size?: string;
  children?: ReactElement | string;
}

export const Label: FC<LabelProps> = ({ name, size = "md", children, klass = "", htmlFor }) => {
  const id = name || htmlFor || undefined;
  return (
    <label className={cn(Styles.label, size, klass)} htmlFor={id}>
      {children}
    </label>
  );
};

export default Label;
